module.exports = __webpack_public_path__ + "img/Breaking_Bad_splash.15991dc9.jpg";